import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { RouteConstants } from '../../constants/routes';
import { environment } from '../../../../environments/environment';
import { GoStorageService } from '../../../modules/application/go/go-parameters/services/go-storage/go-storage.service';

/**
 * This service centralizes all authentication flows using the Auth0 SDK for the application.
 * It provides a single point of interaction with the Auth0 SDK, ensuring consistent behavior
 * across all components and services that require SDK-based authentication functionality.
 */
@Injectable({
    providedIn: 'root',
})
export class AuthFlowService {
    constructor(
        private readonly auth0Service: AuthService,
        private readonly goStorageService: GoStorageService,
    ) {}

    loginToGo() {
        this.loginWithRedirectPath(
            RouteConstants.Go.getFullRoute('purposeOfFiling'),
        );
    }

    login() {
        this.loginWithRedirectPath(RouteConstants.Dashboard.getRootUrl());
    }

    register() {
        this.auth0Service.loginWithRedirect({
            appState: {
                target: RouteConstants.Dashboard.getRootUrl(),
            },
            authorizationParams: {
                screen_hint: 'signup',
            },
        });
    }

    logout() {
        this.goStorageService.clearCacheData();

        this.auth0Service.logout({
            logoutParams: {
                returnTo: environment.logoutReturnTo,
            },
        });
    }

    registrationComplete(): void {
        this.auth0Service.logout({
            logoutParams: {
                returnTo: environment.registrationCompleteLogoutReturnTo,
            },
        });
    }

    private loginWithRedirectPath(afterLoginRedirectPath: string) {
        this.auth0Service.loginWithRedirect({
            appState: {
                target: afterLoginRedirectPath,
            },
        });
    }
}
